import * as firebase from 'firebase';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';
import { SpinnerService } from '@app/@shared/spinner/spinner.service';
import { UserService } from '@app/services/user.service';
import { SurveyService } from '@app/services/survey.service';
import { ActivatedRoute } from '@angular/router';
import { ActiveStatus } from '@app/interface/common';
import { Constant } from '@app/@core';
import { StudiesService } from '@app/services/studies.service';
import { StudyModel } from '@app/interface/study.model';
import { UserGroupService } from '@app/services';
import { UserGroupModel } from '@app/interface/userGroup.model';
import { StudyAccessType } from '@app/@shared/enums';

@Component({
  selector: 'app-add-survey',
  templateUrl: './addEditSurvey.component.html',
  styleUrls: ['./addEditSurvey.component.scss'],
})
export class AddEditSurveyComponent implements OnInit {
  surveyForm: FormGroup;
  submitted = false;
  success: boolean;
  date = new Date().toISOString();
  isLoading = false;
  surveyStatus: ActiveStatus[] = Constant.ActiveStatus;
  @Input() title_tag: string;
  @Input() formType: string;
  @Input() form_data: any;
  studyDetail: StudyModel;
  userGroupsOptins: Array<UserGroupModel> = [];
  userGroups: Array<UserGroupModel> = [];

  constructor(
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private surveyService: SurveyService,
    private studiesService: StudiesService,
    private userGroupServie: UserGroupService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getstudyDetail();
    this.getUserGroups();
  }

  private getstudyDetail(studyName?: string): void {
    this.studiesService.getStudyDetailById().subscribe((study: StudyModel) => {
      this.studyDetail = study;
      if (this.studyDetail?.studyAccessType === StudyAccessType.DEFAULT) {
        this.surveyForm.get('groupIds').clearValidators();
        this.surveyForm.get('groupIds').updateValueAndValidity();
      }
    });
  }

  private createForm(): void {
    this.surveyForm = this.formBuilder.group({
      uuid: [],
      name: ['', [Validators.required()]],
      description: ['', [Validators.required()]],
      isActive: [false, [Validators.required()]],
      startdate: [firebase.default.firestore.Timestamp.now()],
      groupIds: [new Array(), [Validators.required()]],
    });
    if (this.formType === 'Edit') {
      this.surveyForm.patchValue(this.form_data);
    }
  }

  get formControl() {
    return this.surveyForm.controls;
  }

  public save(): void {
    this.submitted = true;
    if (this.surveyForm.valid) {
      const surveyData = this.surveyForm.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateSurvey(surveyData);
      } else {
        this.submitAddEditSurvey(surveyData);
      }
    } else {
      return;
    }
  }

  private submitAddEditSurvey(surveyData: any): void {
    this.surveyService.addSurvey(surveyData, this.studyDetail).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  private updateSurvey(surveyData: any): void {
    this.surveyService.updateSurvey(surveyData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  private getRupteParmas(): void {
    this.studiesService.routeParams$.subscribe((params) => {
      if (params) {
        this.getstudyDetail(params.name);
      }
    });
  }

  private getUserGroups(): void {
    this.userGroupServie.getUserGroups().subscribe((userGroups: UserGroupModel[]) => {
      this.userGroupsOptins = userGroups;
      this.checkGroupIds();
    });
  }

  private getDefaultStudyGroup(): void {
    this.userGroupServie.getDefaultStudyGroup().subscribe((defaultGroup: UserGroupModel) => {});
  }

  private checkGroupIds(): void {
    let studyId = this.studiesService.getStudyId();
    let groupIds = this.surveyForm.get('groupIds').value;
    if (groupIds && groupIds.length === 0) {
      let defaultGroup = this.userGroupsOptins.find((item) => item.studyId === studyId && item.isDefault === true);

      this.surveyForm.get('groupIds').patchValue([defaultGroup.uuid]);
    }
  }
}
